import React from "react";
import { Alert, Box, Typography } from "@mui/material";
import moment from "moment-timezone";

// Shown inside the Check In / Check Out popup after a multi-employee action: how many were done,
// which days were left out (weekends / holidays) and who was skipped and why.
const GroupResultView = ({ result, isCheckIn }) => {
  const summary = result?.summary || {};
  const leftOutDays = summary.skippedDays || [];
  const skipped = (result?.results || []).filter((r) => r.status !== "done");

  return (
    <Box>
      <Alert severity={summary.processed ? "success" : "warning"} sx={{ mb: 2 }}>
        {summary.processed} employee(s) {isCheckIn ? "checked in" : "checked out"} ({summary.daysDone} day record(s)).{" "}
        {summary.skipped} skipped.
      </Alert>
      {leftOutDays.length > 0 && (
        <Alert severity="info" sx={{ mb: 2 }} data-testid="left-out-days">
          Left out for everyone:{" "}
          {leftOutDays
            .map((d) => `${moment(d.date, "YYYY-MM-DD").format("ddd D MMM")} (${d.kind === "holiday" ? `holiday: ${d.label}` : "non-working day"})`)
            .join(", ")}
          . Tick &quot;Include Non_Scheduled Days&quot; to include them.
        </Alert>
      )}
      {skipped.length > 0 && (
        <Box sx={{ maxHeight: 260, overflowY: "auto" }}>
          <Typography sx={{ fontSize: 13, fontWeight: 600, mb: 1 }}>Skipped / partly done</Typography>
          {skipped.map((r) => (
            <Box
              key={r.employeeId}
              sx={{ display: "flex", justifyContent: "space-between", gap: 2, py: 0.5, borderBottom: "1px solid #eee" }}
            >
              <Typography sx={{ fontSize: 14 }}>{r.name}</Typography>
              <Typography sx={{ fontSize: 13, color: "#777", textAlign: "right" }}>{r.reason}</Typography>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default GroupResultView;
